import { ArrowBack } from '@mui/icons-material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { doc, setDoc } from 'firebase/firestore';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { db } from '../../firebase';
import { EmployerSelectors } from '../../reducers/employer';
import AppBarComp from '../AppBarComp';
const { NotificationManager } = require('react-notifications');

interface EmployerProfileProps {

}

type Props = EmployerProfileProps;


const EmployerProfile: FC<Props> = (props: Props) => {
    const employer = useSelector(EmployerSelectors.currentEmployer);
    const [companyName, setCompanyName] = useState(employer?.companyName || "");
    const [contactName, setContactName] = useState(employer?.name || "");
    const [address, setAddress] = useState(employer?.address || "");
    const [phone, setPhone] = useState(employer?.phone || "");
    const [about, setAbout] = useState(employer?.about || "");
    const [isSaving, setIsSaving] = useState(false);

    const navigate = useNavigate();

    useEffect(()=>{
        if(!employer){
            navigate("/employer/find");
        }
    },[]);

    const save = () => {
        if (employer?.email && companyName && contactName && address && phone && !isSaving) {
            setIsSaving(true);
            const isProfileUpdatedForTheFirstTime = !employer.profileUpdated;
            setDoc(doc(db, "employers", employer.email), {
                name: contactName,
                phone,
                address,
                companyName,
                about,
                profileUpdated: true
            }, { merge: true })
                .then(() => {
                    setIsSaving(false);
                    NotificationManager.success('Changes were saved successfully!',);
                    if (isProfileUpdatedForTheFirstTime) {
                        navigate("/employer/find");
                    }
                })
                .catch(() => {
                    setIsSaving(false);
                    NotificationManager.error('Something went wrong. Please try again.',);
                });
        }
        else {
            NotificationManager.error('Please fill in the required fields.',);
        }

    }

    return <Box height={{ xs: "initial", md: "100vh", background: "#f5f5f5" }} minHeight="100vh" display="flex" flexDirection="column" >
        <AppBarComp />
        <Container maxWidth="md" sx={{ display: "flex", flexDirection: "column", flex: 1, pt: 3, pb: { xs: "60px", md: "40px" } }}>
            <Box display="flex" height="100%" gap={3} flexDirection="column">
                <Card>
                    <Button onClick={() => { navigate("/employer/find") }} sx={{ mt: 1.5 }}>
                        <Box display="flex" alignItems="center" color="GrayText" >
                            <ArrowBack fontSize='small' sx={{ mr: 1 }} color="inherit" />
                            <Typography fontSize="0.85rem" >Find Candidates</Typography>
                        </Box>
                    </Button>
                    <CardHeader title={"Organization Profile"} />
                    <CardContent>
                        
                        <Stack justifyContent="space-between" gap={3} mb={3}>
                        <Typography fontSize={{ xs: "0.95rem", md: "1rem" }} fontWeight="bold">Company Information</Typography>
                            <TextField value={companyName} onChange={e => setCompanyName(e.target.value)} label="Company Name" size="small" fullWidth required />
                            <TextField multiline fullWidth
                                value={about}
                                onChange={(e) => { setAbout(e.target.value) }}
                                minRows={5}
                                variant="outlined"
                                label="About The Company"
                                placeholder="Interesting facts about the company"
                            />
                            <TextField value={address} onChange={e => setAddress(e.target.value)} label="Company Address" size="small" fullWidth required />
                            <Typography fontSize={{ xs: "0.95rem", md: "1rem" }} mt={2} fontWeight="bold">Contact Information</Typography>
                            <TextField value={employer?.email} label="Email" size="small" disabled fullWidth />
                            <TextField value={contactName} onChange={e => setContactName(e.target.value)} label="Name" size="small" fullWidth required />
                            <TextField value={phone} onChange={e => setPhone(e.target.value)} label="Phone Number" size="small" fullWidth required />
                        </Stack>
                        <Box display="flex" justifyContent={{ xs: "center", md: "flex-end" }} mt={5}>
                            <Button variant="outlined" disabled={isSaving}
                                sx={{ backgroundColor: "#0f4687", color: "white !important", "&:hover": { backgroundColor: "#1d6bca" } }}
                                onClick={save}>
                                {isSaving && <CircularProgress sx={{ width: "18px !important", height: "18px !important", mr: 1, color: "white" }} />}
                                SAVE
                            </Button>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </Container>
    </Box>;
}


export default EmployerProfile;

